import React from 'react';
import { useIntersectionObserver } from './useIntersectionObserver';
export function OpeningHook() {
  const {
    elementRef,
    isVisible
  } = useIntersectionObserver();
  return <section className="bg-navy-light py-16 md:py-24 border-y border-white/5" data-id="element-297">
      <div ref={elementRef} className={`max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-6 text-gray-200 fade-in-section ${isVisible ? 'is-visible' : ''}`} data-id="element-298">
        <p className="text-xl md:text-2xl leading-relaxed" data-id="element-299">
          Cada año haces lo correcto.
        </p>

        <p className="text-xl md:text-2xl leading-relaxed" data-id="element-300">
          Trabajas duro. Aguantas. Pagas tus taxes a tiempo.
        </p>

        <p className="text-xl md:text-2xl leading-relaxed" data-id="element-301">
          Y esperas ese reembolso que sientes que mereces.
        </p>

        <p className="text-xl md:text-2xl leading-relaxed" data-id="element-302">
          Pero cuando llega... algo no cuadra.
        </p>

        <p className="text-3xl md:text-4xl font-heading italic text-gold-light text-center py-4" data-id="element-303">
          "¿Esto es todo?"
        </p>

        <p className="text-xl md:text-2xl leading-relaxed" data-id="element-304">
          Esa sensación en el estómago — de que el número debió haber sido más
          alto — no es imaginación.
        </p>

        <p className="text-xl md:text-2xl leading-relaxed font-semibold text-white" data-id="element-305">
          Es instinto. Y tu instinto tiene razón.
        </p>

        <p className="text-xl md:text-2xl leading-relaxed" data-id="element-306">
          Mientras tú recibiste lo que tu preparador puso en el formulario... el
          IRS guardó silencio sobre el resto.
        </p>

        <p className="text-xl md:text-2xl leading-relaxed text-gray-400" data-id="element-307">
          No te llamaron. No te enviaron carta. No te dijeron nada.
        </p>

        <p className="text-xl md:text-2xl leading-relaxed" data-id="element-308">
          ¿Por qué harían eso?
        </p>

        <div className="bg-navy-dark p-6 md:p-8 rounded-xl border border-gold-primary/20 mt-4 shadow-lg" data-id="element-309">
          <p className="text-xl md:text-2xl leading-relaxed font-bold text-white" data-id="element-310">
            Porque tú no preguntaste.
          </p>
          <p className="text-xl md:text-2xl leading-relaxed mt-4 text-gold-light" data-id="element-311">
            Y ellos no tienen obligación de decirte lo que no preguntas.
          </p>
        </div>
      </div>
    </section>;
}